import React, { useState, useEffect } from 'react';
import { Form, Button, Spin, message, Typography, Card, Switch, Select, Input } from 'antd';
import { useNavigate } from 'react-router-dom';
import GoogleAuthButton from './GmailIntegration';
import useDocumentPageHook from '../DocumentPage/DocumentPageHook';

const { Title } = Typography;
const { TextArea } = Input;

const IntegrationPage = () => {
  const { getEmailContext, createOrUpdateEmailContext, getIntegrationStatus } = useDocumentPageHook();

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [emailAutomation, setEmailAutomation] = useState(false);
  const [integrationStatus, setIntegrationStatus] = useState({ gmail: false });

  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);
      try {
        const emailContext = await getEmailContext();
        if (emailContext) {
          form.setFieldsValue(emailContext);
          setEmailAutomation(emailContext.emailAutomation);
        }

        const status = await getIntegrationStatus();
        if (status) {
          setIntegrationStatus(status);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    }
    fetchData();
  }, [form]);

  const handleSubmit = async (values) => {
    const formData = {
      emailAutomation,
      automationLevel: values.automationLevel,
      emailTemplateName: values.emailTemplateName,
      emailTemplateTitle: values.emailTemplateTitle,
      emailCallToAction: values.emailCallToAction,
    };

    try {
      await createOrUpdateEmailContext(formData);
    } catch (error) {
      console.error('Failed to save email setup:', error);
    }
  };

  const handleValidationError = (errorInfo) => {
    if (errorInfo.errorFields && errorInfo.errorFields.length > 0) {
      const errorMessage = errorInfo.errorFields.map(field => `${field.name[0]}: ${field.errors[0]}`).join(', ');
      message.error(errorMessage);
    } else {
      console.log(errorInfo);
      message.error('Form submission failed');
    }
  };

  const updateIntegrationStatus = async () => {
    try {
      const status = await getIntegrationStatus();
      setIntegrationStatus(status);
    } catch (error) {
      console.error('Failed to update integration status:', error);
    }
  };

  return (
    <div className="preference-page">
      {isLoading ? (
        <Spin size="large" />
      ) : (
        <div style={{
          minWidth: '792px',
          margin: '0 auto',
          padding: '22px 66px',
          backgroundColor: '#fff',
          borderRadius: '16px',
          boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          minHeight: '0'
        }}>
          <Title level={3}>Integration</Title>
          <GoogleAuthButton updateIntegrationStatus={updateIntegrationStatus} integrationStatus={integrationStatus.gmail} />

          <Title level={3} style={{ marginTop: '20px' }}>Email Setup</Title>
          <Form form={form} onFinish={handleSubmit} layout="vertical">
            <Form.Item
              name="emailAutomation"
              label="Enable Email Automation"
              valuePropName="checked"
            >
              <Switch checked={emailAutomation} onChange={setEmailAutomation} />
            </Form.Item>

            {emailAutomation && (
              <>
                <Form.Item
                  name="automationLevel"
                  label="Automation Level"
                  initialValue="need_approval"
                  rules={[{ required: true, message: 'Please select automation level' }]}
                >
                  <Select placeholder="Select automation level">
                    <Select.Option value="automatically">Send automatically</Select.Option>
                    <Select.Option value="need_approval">Need approval</Select.Option>
                  </Select>
                </Form.Item>

                <Title level={4}>Email Template</Title>
                <Form.Item
                  name="emailTemplateName"
                  label="Name"
                  rules={[{ required: true, message: 'Please provide a name' }]}
                  initialValue="Ryan"
                >
                  <Input placeholder="Enter name" />
                </Form.Item>
                <Form.Item
                  name="emailTemplateTitle"
                  label="Title"
                  rules={[{ required: true, message: 'Please provide a title' }]}
                  initialValue="A.I SDR for [company name]"
                >
                  <Input placeholder="Enter title" />
                </Form.Item>
                <Form.Item
                  name="emailCallToAction"
                  label="Call to action"
                  initialValue=""
                >
                  <TextArea placeholder="Would you like to schedule a demo wit us?" />
                </Form.Item>                
              </>
            )}

            <Form.Item style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                onClick={() =>
                  form.validateFields()
                    .then(handleSubmit)
                    .catch(handleValidationError)
                }
                style={{ float: 'right' }}
              >
                Save
              </Button>
            </Form.Item>
          </Form>
        </div>
      )}
    </div>
  );
};

export default IntegrationPage;


